import { render, staticRenderFns } from "./FactorHistoryDesktop.vue?vue&type=template&id=387ce3bf&scoped=true"
import script from "./FactorHistoryDesktop.vue?vue&type=script&lang=js"
export * from "./FactorHistoryDesktop.vue?vue&type=script&lang=js"
import style0 from "./FactorHistoryDesktop.vue?vue&type=style&index=0&id=387ce3bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ce3bf",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QSpace,QBtn,QInput,QTooltip,QTable,QTr,QPopupEdit,QField,QIcon,QPopupProxy,QDate,QBadge,QChip,QDialog});qInstall(component, 'directives', {ClosePopup});
